import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Banner from "./Banner";
import Products from "./Products/components/Products";
import Network from "./Network/components/Network";
import { Advantages } from "./Advantages/Advantages";
import { CommonQuestions } from "./CommonQuestions/components/CommonQuestions";

import useGoogleTagManager from "../../../hooks/useGTM";

function scrollToHashTarget(hash: string) {
  if (!hash) {
    window.scrollTo({ top: 0, left: 0 });
    return;
  }

  const elementId = decodeURIComponent(hash.replace(/^#/, ""));
  const element = document.getElementById(elementId);

  if (element) {
    element.scrollIntoView({ block: "start" });
  }
}

export function Home() {
  const { pathname, hash } = useLocation();
  const { pageInfoEvent } = useGoogleTagManager();

  useEffect(() => {
    pageInfoEvent({
      page_location: "/home",
      page_path: pathname,
    });
  }, [pathname, pageInfoEvent]);

  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      scrollToHashTarget(hash);
    });

    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [pathname, hash]);

  return (
    <>
      <Banner />
      <Products />
      <Advantages />
      <Network />
      <CommonQuestions />
    </>
  );
}

export default Home;